module.exports = __webpack_public_path__ + "static/media/obric.0ae06edf.png";